import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from '../../../helpers/config';
import { getPrepareHeaders } from '../get-prepare-headers';
import { IdEntity } from '../../../interfaces/common-interfaces';
import {
  FFCards,
  PedagogeMaxOre,
  PedagogeNrEvidencave,
  ShperndarjaPedagogeLojiItem,
  StudenteNderVite,
  StudenteProfile,
  StudentetNeKlasa,
} from '../../../interfaces/dashboard';

const {
  test: { baseUrl },
} = getConfig();

export const dashboardFFApi = createApi({
  reducerPath: 'dashboardFFStats',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['DashboardFFStats'],
  endpoints: builder => ({
    kartat: builder.query<FFCards, IdEntity>({
      query: ({ id }) => `statistika-ff/kartat/${id}`,
    }),
    getStudentetNeKlasa: builder.query<StudentetNeKlasa[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-ff/studentet-ne-klasa/${id}`,
      }),
    }),

    getStudenteProfile: builder.query<StudenteProfile[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-ff/studente-profile/${id}`,
      }),
    }),

    getStudenteNderVite: builder.query<StudenteNderVite[], void>({
      query: () => ({
        url: '/statistika-ff/studente-nder-vite',
      }),
    }),

    getShperndarjaPedagogeLojiQuery: builder.query<
      ShperndarjaPedagogeLojiItem[],
      IdEntity
    >({
      query: ({ id }) => ({
        url: `/statistika-ff/shperndarja-pedagoge-lloji/${id}`,
      }),
    }),

    getPedagogeNrEvidencave: builder.query<PedagogeNrEvidencave[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-ff/pedagoge-nr-evidencave/${id}`,
      }),
    }),

    getPedagogeMaxOre: builder.query<PedagogeMaxOre[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-ff/pedagoge-max-ore/${id}`,
      }),
    }),

    getKartat: builder.query<FFCards, IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-ff/kartat/${id}`,
      }),
    }),
  }),
});

export const {
  useGetStudentetNeKlasaQuery,
  useGetStudenteProfileQuery,
  useGetStudenteNderViteQuery,
  useGetShperndarjaPedagogeLojiQueryQuery,
  useGetPedagogeNrEvidencaveQuery,
  useGetPedagogeMaxOreQuery,
  useKartatQuery,
} = dashboardFFApi;
